import * as React from 'react';
import {normalizeColor} from "../../../ts/common/SiteHelper";
import {Point, PointLike} from "maplibre-gl";
import BasicComponent from "../../../tsx/component/BasicComponent";

export interface IMapMarkerIconProps
{
    color?: string,
    innerColor?: string,
    strokeColor?: string,
    size?:[number, number];
    scale?: number,
    imagePath?: string,
    imageIconOrigin?:PointLike
    imageIconInternalOrigin?:PointLike
    imageIconTopLeftAdditionalOffset?:PointLike
    imageIconBottomRightAdditionalOffset?:PointLike
}

export class MapMarkerIconInstance extends BasicComponent<IMapMarkerIconProps>
{
    props: IMapMarkerIconProps;

    defaultSize:[number, number] = [27, 41];
    standardSize:[number, number] = [0, 0];
    size:[number, number] = [0, 0];

    scale:number = 1;
    standardBodyHeight:number = 33;
    bodyHeight:number = 0;

    color:string = "";
    innerColor:string = "";
    strokeColor:string = "";


    constructor(props: IMapMarkerIconProps)
    {
        super(props);
        this.props = props;
    }

    applyNextProps(nextProps:IMapMarkerIconProps, props?:IMapMarkerIconProps)
    {
        super.applyNextProps(nextProps, props);
        this.scale = nextProps.scale ?? 1;

        let standardSize:[number, number]|null = null;
        let size:[number, number]|null = null;
        if(props){
            if(props.size === nextProps.size){
                standardSize = this.standardSize;
                size = this.size;
            }
        }
        this.standardSize = standardSize ?? this.getScaledSize(1, nextProps.size);
        this.size = size ?? this.getScaledSize(this.scale, nextProps.size)

        this.bodyHeight = this.standardBodyHeight * this.scale;

        const notFoundColor =  "#FFFFFF";
        this.color = normalizeColor(nextProps.color) ?? notFoundColor;
        this.innerColor = normalizeColor(nextProps.innerColor) ?? notFoundColor;
        this.strokeColor = normalizeColor(nextProps.strokeColor) ?? notFoundColor;
    }

    getScaledSize(scale?:number, fromSize?:[number, number]):[number, number] {

        scale = scale ?? 1;
        fromSize = fromSize ?? this.defaultSize;
        const sizeWidth = fromSize[0];
        const sizeHeight = fromSize[1];

        return [sizeWidth * scale, sizeHeight * scale];
    }

    getPopUpOffset(directionAnchor:  "bottom"|"top"|"right"|"left"|"center"):Point
    {

        const sizeWidth = this.size[0];
        const sizeHeight = this.size[1];
        const origin = this.getOrigin() ?? new Point(0, 0)
        const internalOrigin = this.getInternalOrigin() ?? new Point(0, 0)
        const topLeftAdditionalOffset = this.getTopLeftAdditionalOffset() ?? new Point(0, 0)
        const bottomRightAdditionalOffset = this.getBottomRightAdditionalOffset() ?? new Point(0, 0)

        let yProp = origin.y;
        if(directionAnchor === "bottom"){
            yProp += -0.5;
        } else if(directionAnchor === "top"){
            yProp += 0.5;
        } else {
            yProp += internalOrigin.y;
        }

        let xProp = origin.x;
        if(directionAnchor === "right"){
            xProp += -0.5;
        } else if(directionAnchor === "left"){
            xProp += 0.5;
        } else {
            xProp += internalOrigin.x;
        }

        let yAdditionalOffset = 0;
        let xAdditionalOffset = 0;

        if(directionAnchor === "bottom"){
            yAdditionalOffset = topLeftAdditionalOffset.y;
        } else if(directionAnchor === "top"){
            yAdditionalOffset = bottomRightAdditionalOffset.y;
        } else if(directionAnchor === "right"){
            xAdditionalOffset = topLeftAdditionalOffset.x;
        } else if(directionAnchor === "left"){
            xAdditionalOffset = bottomRightAdditionalOffset.x;
        }

        const x = sizeWidth * xProp + xAdditionalOffset * this.scale;
        const y = sizeHeight * yProp + yAdditionalOffset * this.scale;

        return new Point(x, y)
    }

    getOrigin():Point|null
    {
        return new Point(0, -0.5);
    }

    getInternalOrigin():Point|null
    {
        return new Point(0, -0.1)
    }

    getTopLeftAdditionalOffset():Point|null
    {
        return new Point(-1, 4);
    }

    getBottomRightAdditionalOffset():Point|null
    {
        return new Point(1, 0);
    }

    renderComponent()
    {
        const sizeWidth = this.size[0];
        const sizeHeight = this.size[1];
        const standardSizeWidth = this.standardSize[0];
        const standardSizeHeight = this.standardSize[1];

        return <div style={{marginTop: "-" + (this.bodyHeight / 2)+ "px"}}>
            <svg className="icon" display="block" width={sizeWidth+"px"} height={sizeHeight+"px"} viewBox={"0 0 "+ standardSizeWidth +" "+standardSizeHeight}>
                <g fillRule="nonzero">
                    <g transform="translate(3.0, 29.0)" fill={this.strokeColor}>
                        <ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse>
                        <ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse>
                        <ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="9.5" ry="4.77275007"></ellipse>
                        <ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="8.5" ry="4.29549936"></ellipse>
                        <ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="7.5" ry="3.81822308"></ellipse>
                        <ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="6.5" ry="3.34094679"></ellipse>
                        <ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="5.5" ry="2.86367051"></ellipse>
                        <ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="4.5" ry="2.38636864"></ellipse>
                    </g>
                    <g fill={this.color}>
                        <path d="M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z">

                        </path>
                    </g>
                    <g opacity="0.25" fill={this.strokeColor}>
                        <path d="M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z">

                        </path>
                    </g>
                    <g transform="translate(6.0, 7.0)" fill={this.innerColor}>

                    </g>
                    <g transform="translate(8.0, 8.0)">
                        <circle fill={this.strokeColor} opacity="0.25" cx="5.5" cy="5.5" r="5.4999962">

                        </circle>
                        <circle fill={this.innerColor} cx="5.5" cy="5.5" r="5.4999962">

                        </circle>
                    </g>
                </g>
            </svg>
        </div>
    }
}

const MapMarkerIcon  = React.memo(MapMarkerIconInstance);
export default MapMarkerIcon;